/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfDeviceFullDto } from '../../models/platform-api-result-of-device-full-dto';

export interface GetDevicesQueryPcnamePcname$Params {
  pcName: string;
}

export function getDevicesQueryPcnamePcname(http: HttpClient, rootUrl: string, params: GetDevicesQueryPcnamePcname$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDeviceFullDto>> {
  const rb = new RequestBuilder(rootUrl, getDevicesQueryPcnamePcname.PATH, 'get');
  if (params) {
    rb.path('pcName', params.pcName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfDeviceFullDto>;
    })
  );
}

getDevicesQueryPcnamePcname.PATH = '/api/devices/query/pcname/{pcName}';
